import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import { getColumns, getData, getIsLoading } from '../redux/selectors/PreAdviceTransactionsHistorySelectors';
import ListTable from '../../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import ManualPreadviceTransactionsEdit from '../../../manual-preadvice/edit/container/ManualPreadviceTransactionsEdit';
import ManualPreadviceTransactionsDelete
  from '../../../manual-preadvice/delete/containers/ManualPreadviceTransactionsDelete';
import { postManualPreadviceTransactionsApplyRequestActionCreator } from '../../../manual-preadvice/apply/redux/actions/ManualPreadviceTransactionsApplyActions';
import { getUserRole } from '../../../../../../common/user/redux/selectors/UserDataSelectors';

class PreAdviceTransactionsHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditFormModal: false,
      showDeleteModal: false,
      transactionIds: this.props.row.original.id,
    };
    this.editTransaction = this.editTransaction.bind(this);
    this.deleteTransaction = this.deleteTransaction.bind(this);
    this.applySavedStatusToOpen = this.applySavedStatusToOpen.bind(this);
  }

  componentDidMount() {
    this.refreshHistories();
  }

  refreshHistories = () => {
    this.props.tableLoadData(
      {
        tableId: TableDefinitions.PREADVICE_TRANSACTIONS_HISTORY.id,
      },
      this.props.appContext.appContext,
      {
        transactionId: this.props.row.original.id,
      },
    );
  }

  showEditFormModal = () => {
    this.setState({
      showEditFormModal: true,
    });
  }

  hideEditFormModal = () => {
    this.setState({
      showEditFormModal: false,
    });
  }

  showDeleteFormModal = () => {
    this.setState({
      showDeleteModal: true,
    });
  }

  hideDeleteFormModal = () => {
    this.setState({
      showDeleteModal: false,
    });
  }

  async applySavedStatusToOpen() {
    await this.props.postManualPreadviceTransactionsApplyRequestActionCreator(
      this.props.appContext,
      [this.state.transactionIds],
    );
    this.props.refreshTransactions();
    this.refreshHistories();
  }

  editTransaction() {
    this.setState({
      showEditFormModal: true,
    });
  }

  deleteTransaction() {
    this.setState({
      showDeleteModal: true,
    });
  }

  render() {
    const {
      showEditFormModal,
      showDeleteModal,
    } = this.state;
    return (
      <div>
        {this.props.row.original.status !== 'DELETED'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER'))
        && (
          <Button className="action-buttons" onClick={this.editTransaction}>Edit</Button>
        )}
        {this.props.row.original.status === 'SAVED'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons" onClick={this.applySavedStatusToOpen}>
            Apply Manual Pre-Advice Adjustment
          </Button>
        )}
        {this.props.row.original.status !== 'DELETED'
        && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons" onClick={this.deleteTransaction}>
            Delete
          </Button>
        )}
        <ListTable
          listId={TableDefinitions.PREADVICE_TRANSACTIONS_HISTORY.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
        />
        {showEditFormModal && (
          <ManualPreadviceTransactionsEdit
            openDialog={this.showEditFormModal}
            closeDialog={this.hideEditFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
        {showDeleteModal && (
          <ManualPreadviceTransactionsDelete
            openDialog={this.showDeleteFormModal}
            closeDialog={this.hideDeleteFormModal}
            row={this.props.row.original}
            refreshTransactions={this.props.refreshTransactions}
            refreshHistories={this.refreshHistories}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
  };
}

PreAdviceTransactionsHistoryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  row: PropTypes.objectOf(PropTypes.shape),
  postManualPreadviceTransactionsApplyRequestActionCreator: PropTypes.func,
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
  refreshTransactions: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  postManualPreadviceTransactionsApplyRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PreAdviceTransactionsHistoryContainer);
